import React from 'react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import PageHero from '../Elements/PageHero';
import AboutManagement from '../Elements/AboutManagement';
import CtaBand from '../Elements/CtaBand';
import Contact from '../Elements/Contact';
import useReveal from '../../hooks/useReveal';
import usePageMeta from '../../hooks/usePageMeta';
import { managementServices as data } from '../../content/site';

const ServicesManagement = () => {
  useReveal();
  usePageMeta({
    title: `${data.title} | LIDA Engineering`,
    description: data.lead,
  });

  return (
    <>
      <Header overHero />
      <main id="main" className="page-content">
        <PageHero
          eyebrow={data.eyebrow}
          title={data.title}
          lead={data.lead}
          image={data.heroImage}
          imageAlt="LIDA Engineering crew carrying out groundworks on a commercial site"
        />
        <AboutManagement />
        <CtaBand />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

export default ServicesManagement;
